/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const CodeMin = 3;
export const CodeMax = 3;

export const CodeRegExp = new RegExp("^[A-Z]{3}$");

export const Code = zod.string().min(CodeMin).max(CodeMax).regex(CodeRegExp);

export type Code = zod.input<typeof Code>;
export type CodeOutput = zod.output<typeof Code>;
